import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Loe kõiki meie sisustuslugusid

  <span style="color:#85c1dc;">**FI:**</span>
  Lue kaikki sisustustarinamme

  <span style="color:#85c1dc;">**RU:**</span>
  Прочитай все наши истории дизайна интерьера
*/
/* @__NO_SIDE_EFFECTS__ */
const m890 = msg(
  mf`Loe kõiki meie sisustuslugusid`,
  mf`Lue kaikki sisustustarinamme`,
  mf`Прочитай все наши истории дизайна интерьера`,
)

export { m890 as 'w.module.blog_grid.action.text' }